<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card :text="modal">
        <v-card-title class="pb-0">
          <h1 class="headline font-weight-medium mb-2 mx-1">
            {{ header }}
            <InvoicePaymentsLabel
              :invoice-amount="totalAmount"
              :payments-amount="totalAmountInvoices"
            />
          </h1>
          <v-spacer />
          <ActionsModalWindow
            v-if="modal"
            :id="id"
            component-name="Invoice"
            @close="$emit('close')"
          />
        </v-card-title>
        <v-form>
          <v-card-text class="py-0">
            <v-row>
              <v-col md="6" sm="6" cols="12" class="mb-n4 pb-0">
                <DatePicker
                  v-model="date"
                  default-value
                  :filled="false"
                  label="Дата*"
                  :error-messages="$v.date.$error ? errors.DATE : []"
                  :hide-details="false"
                  @input="$v.date.$touch()"
                />
              </v-col>

              <v-col md="6" sm="6" cols="12" class="mb-n4 pb-0">
                <CustomTextField
                  v-model="number"
                  label="№"
                  required
                  :error-messages="$v.number.$error ? errors.NUMBER : []"
                  :hide-details="false"
                  @input="$v.number.$touch()"
                />
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="mb-n4 pb-0">
                <ClientSelect
                  v-model="client"
                  :client-id="client && client.id"
                  :rules="rules.client"
                  label="Клієнт*"
                  :error-messages="$v.client.title.$error ? errors.CLIENT : []"
                  :hide-details="false"
                  @input="$v.client.$touch()"
                />
              </v-col>
            </v-row>
            <div>
              <v-tabs v-model="tab" slider-color="red lighten-2">
                <v-tab>Деталі ({{ totalAmount | decimal }}) </v-tab>
                <v-tab>Сплати ({{ totalAmountInvoices | decimal }}) </v-tab>
                <v-tabs-items v-model="tab" class="py-3">
                  <v-tab-item>
                    <v-card text flat>
                      <v-row dense>
                        <v-col cols="12">
                          <v-row>
                            <v-col cols="auto">
                              <ServiceMenu @input="addDetailsItem" />
                            </v-col>
                            <v-col cols="auto">
                              <ProductMenu @input="addDetailsItem" />
                            </v-col>
                            <v-col cols="2">
                              <PackageMenu @input="addDetailsItem" />
                            </v-col>
                          </v-row>
                        </v-col>

                        <v-col cols="12">
                          <InvoiceDetailsItem
                            v-for="(item, index) in details"
                            :key="index"
                            class="my-3"
                            :item="item"
                            @remove="removeDetailsItem"
                            @change="isChanged = true"
                          />
                        </v-col>

                        <v-col v-show="details.length !== 0" offset="8">
                          <p right class="title">
                            Разом:<span class="ma-1">{{
                              totalAmount | decimal
                            }}</span>
                          </p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card text flat>
                      <v-data-table
                        :headers="headers"
                        :items="paymentInvoices"
                        flat
                        hide-default-footer
                      >
                        <template v-slot:item="{ item }">
                          <td>
                            <ReferenceTitle
                              :id="item.id"
                              component-name="Payment"
                              :title="item.id"
                            />
                          </td>
                          <td>{{ item.date | date }}</td>
                          <td>{{ item.amount }}</td>
                        </template>
                      </v-data-table>

                      <v-row v-show="details.length !== 0">
                        <v-col offset="8" cols="4">
                          <p right class="title mt-2">
                            Разом:<span class="ma-1">{{
                              totalAmountInvoices | decimal
                            }}</span>
                          </p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-tabs>
            </div>
          </v-card-text>

          <v-card-actions v-if="!modal">
            <PrimaryBtn
              :has-warnings="$v.$invalid"
              :loading="loading"
              @click="save"
            />
            <v-btn @click="$router.go(-1)">
              Відмінити
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClientSelect from "@/components/selects/ClientSelect";
import ServiceMenu from "./ServiceMenu";
import PackageMenu from "./PackageMenu";
import ProductMenu from "./ProductMenu";
import InvoiceDetailsItem from "./InvoiceDetailsItem";
import DatePicker from "@/components/story/DatePicker";
import * as invoicesApi from "../../../backend/invoicesApi.js";
import { getPaymentInvoices } from "../../../backend/paymentsApi.js";
import InvoicePaymentsLabel from "./InvoicePaymentsLabel";
import ReferenceTitle from "../../../components/ReferenceTitle.vue";
import { ERRORS } from "@/helpers";
import { required } from "vuelidate/lib/validators";
import PrimaryBtn from "@/components/PrimaryBtn.vue";

export default {
  components: {
    ClientSelect,
    ServiceMenu,
    PackageMenu,
    ProductMenu,
    InvoiceDetailsItem,
    DatePicker,
    InvoicePaymentsLabel,
    ReferenceTitle,
    PrimaryBtn,
    ActionsModalWindow() {
      return import("@/components/ActionsModalWindow.vue");
    },
  },
  props: ["id", "modal"],
  data: () => ({
    dateMenu: false,
    date: "",
    client: null,
    number: "",
    loading: false,
    isChanged: false,
    rules: {
      number: [(v) => !!v || "Номер обов'язковий"],
      client: [(v) => !!v || "Назва клієнта обов'язкова"],
    },
    details: [],
    tab: "",
    paymentInvoices: [],
    headers: [
      { text: "id", align: "left", sortable: false },
      { text: "Дата", align: "left", sortable: false },
      { text: "Сума", align: "left", sortable: false },
    ],
  }),

  validations: {
    client: {
      id: { required },
      title: { required },
    },
    date: {
      required,
    },
    number: {
      required,
    },
  },

  computed: {
    isNew() {
      return +this.id ? false : true;
    },
    formattedDate() {
      return this.date ? this.moment(this.date).format("DD.MM.YYYY") : "";
    },
    totalAmount() {
      return this.details.reduce((sum, i) => sum + i.amount, 0);
    },
    header() {
      if (this.modal) {
        return "Рахунок на сплату";
      }
      return this.isNew ? "Створення рахунку на сплату" : "Рахунок на сплату";
    },
    totalAmountInvoices() {
      return this.paymentInvoices.reduce((sum, i) => sum + i.amount, 0);
    },
    errors() {
      return {
        CLIENT: [ERRORS.REQUIRED],
        DATE: [ERRORS.REQUIRED],
        NUMBER: [ERRORS.REQUIRED],
      };
    },
  },
  created() {
    if (+this.id) {
      invoicesApi.getInvoice(this.id).then((invoice) => {
        this.date = invoice.date;
        this.number = invoice.number;
        this.client = invoice.client;
        this.details = invoice.details;
      });
    }
    this.getPaymentInvoices();
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      if (!this.isChanged) {
        return;
      }

      this.loading = true;

      const invoice = {
        clientId: this.client.id,
        date: this.date,
        number: this.number,
        packages: this.details
          .filter((di) => di.type === "package")
          .map((p) => {
            return {
              id: p.id,
              amount: p.amount,
            };
          }),
        services: this.details
          .filter((di) => di.type === "service")
          .map((s) => {
            return {
              id: s.id,
              amount: s.amount,
              quantity: s.quantity,
            };
          }),
        products: this.details
          .filter((di) => di.type === "product")
          .map((p) => {
            return {
              id: p.id,
              amount: p.amount,
            };
          }),
      };

      try {
        if (!this.isNew) {
          await invoicesApi.updateInvoice(this.id, invoice);
        } else {
          await invoicesApi.createInvoice(invoice);
        }

        this.$notifySuccess();
        this.$router.go(-1);
      } catch {
        this.$notifyWarning();
      } finally {
        this.loading = false;
        this.isChanged = false;
      }
    },
    onDateChange() {
      this.dateMenu = false;
      this.isChanged = true;
    },
    removeDetailsItem(item) {
      this.details.splice(this.details.indexOf(item), 1);
      this.isChanged = true;
    },
    addDetailsItem(item) {
      if (!item) {
        return;
      }
      this.details.push(item);
      this.isChanged = true;
    },
    async getPaymentInvoices() {
      this.paymentInvoices = await getPaymentInvoices(this.id);
    },
  },
};
</script>
